import React, { useEffect, useState } from "react";
import { Button, Dialog, Grow, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import FlagRoundedIcon from "@mui/icons-material/FlagRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";
import { useDispatch, useSelector } from "react-redux";
import SelectMenuTextField from "../SelectMenuTextField";
import axios from "axios";
import { getBacklogIssues, getLastFiveActiveSprintInfo, getSprintsList, SetlastfiveActiveSprintInfo, updateSprint } from "../../common/Redux/Reducer";
import API_BASE_URL from "../config/appConfig";
import SprintCompleteArt from "./SprintCompleteArt";
import "./modal.scss";
import { useToast } from "../Toast";

const SmoothGrow = React.forwardRef(function SmoothGrow(props, ref) {
    return <Grow ref={ref} timeout={{ enter: 320, exit: 200 }} {...props} />;
});

/* Callers pass free-text labels ("Delete", "Complete"), so the tone is derived
   from those unless one is given explicitly. */
const inferTone = (btnText = "", title = "") => {
    const text = `${btnText} ${title}`.toLowerCase();
    return /delete|remove|discard/.test(text) ? "danger" : "default";
};

const DeleteConfirmationModal = ({ open, handleClose, handleConfirm, setOpenDeleteDialog, description, title, btnText, buttonStyles, activeSprint, AllsprintDetails = [], isCompleteConfirm = false , isActiveSprintExist,setIsActiveSprintExist=()=>{}, tone }) => {
    const [sprintId, setSprintId] = useState(null);
    const [issuesSelected, setIssuesSelected] = useState([]);

    const dispatch = useDispatch();
    const toast = useToast();

    const filterAssigneesArray = useSelector((state) => state.ProjamAppSlice.assignees);
    const filteredSprintDetails = AllsprintDetails.filter(sprint => !sprint.active);
    const { Projects } = useSelector((state) => state.ProjamAppSlice)


  let backlogId = Projects?.selectedProject?.selectedProjectBackLogId
  let projectId = Projects?.selectedProject?.selectedProjectData?._id

    useEffect(() => {
        if (activeSprint && activeSprint.issues) {
            const issueIds = activeSprint.issues.filter((issue) => issue.status !== "Done").map((issue) => issue._id);
            setIssuesSelected(issueIds);
        }
    }, [activeSprint]);

    const handleMoveIssuesToSprint = async (SprintId) => {
        if (SprintId) {
            try {
                const response = await axios.put(`${API_BASE_URL}/issues/moveto/sprint/${SprintId}`, {
                    selectedIssues: issuesSelected,
                });

               await  dispatch(updateSprint({ sprintId: activeSprint?._id, payload: { active: false, completed: true } }));
               await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray }));
               await dispatch(getBacklogIssues(backlogId));
               dispatch(getLastFiveActiveSprintInfo({backlogId , projectId}))
               setOpenDeleteDialog(false);
             setIsActiveSprintExist(false)
               toast.success("Sprint completed and open issues moved");
            } catch (error) {
                console.error('Error moving issues to new sprint:', error);
                toast.error("Could not complete the sprint. Please try again.");
            }
        }
    };
    const handleCompleteprint = async () => {
        if (sprintId) {
            if (sprintId === "123") {
                await CreateNewSprint();
            } else {
                await handleMoveIssuesToSprint(sprintId);

            }
          let response =  dispatch(getLastFiveActiveSprintInfo({backlogId , projectId}))
          dispatch(SetlastfiveActiveSprintInfo(response))
        }
    };

    const CreateNewSprint = async () => {
        setOpenDeleteDialog(false);
        try {
            const response = await axios.post(`${API_BASE_URL}/sprints/createSprint`, {
                backlog: backlogId,
            });
            const newSprintId = response.data._id;
            if (newSprintId) {
                setSprintId(newSprintId);
                await handleMoveIssuesToSprint(newSprintId);
            } else {
                console.error("New sprint ID is not available in the response.");
                toast.error("Could not create the new sprint");
            }
        } catch (error) {
            console.error("Error creating new sprint:", error);
            toast.error("Could not create the new sprint");
        }
    };

    /* IssuecountObj can be missing on a freshly loaded sprint; fall back to
       counting the issues rather than throwing on Object.values(undefined). */
    const getTotalIssueCount = (issueCountObj, fallback = 0) => {
        if (!issueCountObj) return fallback;
        const total = Object.values(issueCountObj).reduce((sum, count) => sum + (Number(count) || 0), 0);
        return total - (Number(issueCountObj['Done']) || 0);
    };

    const handleSelectSprintChange = (e) => {
        const selectedValue = e.target.value;
        setSprintId(selectedValue);
    };

    const openIssuesCount = activeSprint?.issues?.filter(issue => issue.status !== 'Done').length;

    const resolvedTone = tone || inferTone(btnText, title);
    const isDanger = resolvedTone === "danger";
    const hasSprint = isCompleteConfirm && activeSprint && Object.keys(activeSprint)?.length > 0;
    const hasOpenIssues = openIssuesCount > 0;
    // open issues need somewhere to go before the sprint can close
    const needsTarget = hasSprint && hasOpenIssues && !sprintId;

    const paperClassName = [
        "pj-modal",
        isDanger && !isCompleteConfirm ? "pj-modal--danger" : "",
        isCompleteConfirm ? "pj-modal--sprint" : "pj-modal--confirm",
    ].filter(Boolean).join(" ");

    const closeButton = (
        <IconButton className="pj-modal-close" size="small" onClick={handleClose} aria-label="Close">
            <CloseRoundedIcon fontSize="small" />
        </IconButton>
    );

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="xs"
            fullWidth
            TransitionComponent={SmoothGrow}
            PaperProps={{ className: paperClassName }}
            slotProps={{ backdrop: { className: "pj-modal-backdrop" } }}
        >
            {/* ------------------------------------ complete sprint: header */}
            {hasSprint ? (
                <div className="pj-modal-header">
                    <span className="pj-modal-badge" aria-hidden="true">
                        <FlagRoundedIcon />
                    </span>
                    <div className="pj-modal-heading">
                        <h3 className="pj-modal-title" id="alert-dialog-title">Complete {activeSprint?.name}</h3>
                        <p className="pj-modal-sub" id="alert-dialog-description">
                            {hasOpenIssues
                                ? "Some issues are still open. Choose where they should go before this sprint closes."
                                : "Everything in this sprint is done."}
                        </p>
                    </div>
                    {closeButton}
                </div>
            ) : null}

            <div className="pj-modal-body">
                {!hasSprint ? closeButton : null}

                {/* ----------------------------------------- generic confirm */}
                {!isCompleteConfirm ? (
                    <>
                        <span className="pj-modal-badge">
                            {isDanger ? <DeleteOutlineRoundedIcon /> : <HelpOutlineRoundedIcon />}
                        </span>
                        <h3 className="pj-modal-title" id="alert-dialog-title">{title}</h3>
                        <p className="pj-modal-sub" id="alert-dialog-description">{description}</p>
                    </>
                ) : null}

                {/* ------------------------------------ complete sprint: body */}
                {hasSprint ? (
                    <>
                        <SprintCompleteArt variant={hasOpenIssues ? "pending" : "done"} />

                        <div className="pj-modal-stats">
                            <div className="pj-stat is-done">
                                <span className="pj-stat-icon"><TaskAltRoundedIcon /></span>
                                <div>
                                    <strong>{activeSprint?.IssuecountObj?.['Done'] ?? 0}</strong>
                                    <span>Completed</span>
                                </div>
                            </div>
                            {hasOpenIssues ? (
                                <div className="pj-stat is-open">
                                    <span className="pj-stat-icon"><PendingActionsRoundedIcon /></span>
                                    <div>
                                        <strong>{getTotalIssueCount(activeSprint?.IssuecountObj, openIssuesCount)}</strong>
                                        <span>Open</span>
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        {hasOpenIssues ? (
                            <div className="pj-field-group">
                                <label className="pj-field-label">Move open issues to</label>
                                <SelectMenuTextField
                                    labelText="Select Sprint"
                                    options={[...filteredSprintDetails, { _id: '123', name: "New Sprint", value: '123' }]}
                                    onChange={handleSelectSprintChange}
                                    MenuProps={{ disablePortal: false, PaperProps: { className: "pj-modal-select-menu" } }}
                                />
                                {needsTarget ? (
                                    <span className="pj-field-hint">Pick a sprint to continue</span>
                                ) : null}
                            </div>
                        ) : null}
                    </>
                ) : null}
            </div>

            {/* In complete-sprint mode with no sprint loaded there is nothing to
                confirm, so the action row is withheld rather than rendering a
                blank primary button. */}
            {(!isCompleteConfirm || hasSprint) ? (
            <div className="pj-modal-actions">
                <Button className="pj-btn pj-btn--quiet" onClick={handleClose}>
                    Cancel
                </Button>
                {hasSprint ? (
                    <Button
                        className="pj-btn pj-btn--primary"
                        onClick={hasOpenIssues ? handleCompleteprint : handleConfirm}
                        disabled={needsTarget}
                        autoFocus={!needsTarget}
                    >
                        Complete sprint
                    </Button>
                ) : (
                    <Button className="pj-btn pj-btn--primary" onClick={handleConfirm} autoFocus>
                        {btnText}
                    </Button>
                )}
            </div>
            ) : null}
        </Dialog>
    );
};

export default DeleteConfirmationModal;
